




























































import { Mobile } from "@/mixins/mobile";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";

@Component({
  components: { SurchargeBanner },
  directives: {
    "click-outside": {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el: any) {
        document.removeEventListener("click", el._clickOutside);
      }
    }
  }
})
export default class ReviewFooter extends mixins(Mobile) {
  protected isMenuOpen = false;

  protected toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  protected closeMenu(): void {
    this.isMenuOpen = false;
  }

  protected submitQuote(): void {
    this.$emit("submit");
  }

  protected requestSalesOrder(): void {
    this.closeMenu();
    this.$emit("request-sales-order");
  }

  protected goBack(): void {
    this.$router.back();
  }
}
